import { getUserRolesRole } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const USER_ROLES_BY_NAME = "USER_ROLES_BY_NAME";

export function useRoles(role?: string) {
	return useQuery({
		queryKey: [USER_ROLES_BY_NAME, role],
		queryFn: processResponse(() => getUserRolesRole(role!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		throwOnError: true,
		enabled: !!role,
	});
}
